import styled from "styled-components/macro";

const PopoverContent = styled.div`
  padding: 10px;
  max-width: 300px;
`;

const PopoverTitle = styled.div`
  font-size: 18px;
  font-weight: 400;
  text-transform: uppercase;
`;

const PopoverBorder = styled.div`
  height: 1px;
  background: #eceff0;
  margin: 6px 0;
`;

const PopoverMessage = styled.div``;

const PopoverButtonsContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
`;

export {
  PopoverContent,
  PopoverTitle,
  PopoverBorder,
  PopoverMessage,
  PopoverButtonsContainer,
};
